import React, { useContext } from "react";
import { Alert } from "@mui/material";
import { ItemDetailsData } from "../../../../Utils/DefinitionsInterfaces";
import ItemSummary from "./ItemSummary";
import { CartContext } from "../../../../App";

interface SummaryModalBodyProps {
  sections: Array<{ title: string; subTitle: React.ReactNode }>;
  selectedOption: "prepaid" | "cod";
  setSelectedOption: (option: "prepaid" | "cod") => void;
  handleOptionChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
  checkOutItems: ItemDetailsData[];
  proceedToBuy: (paymentType: "prepaid" | "cod") => void;
  isPurchaseButtonClicked: boolean;
  showAlert: { isAlertVisible: boolean; alert: string };
  // Coupon props
  couponState: {
    code: string;
    isApplied: boolean;
    isLoading: boolean;
    discountAmount: number;
    originalAmount: number;
    finalAmount: number;
    error: string;
  };
  couponInput: string;
  setCouponInput: (value: string) => void;
  handleApplyCoupon: () => void;
  handleRemoveCoupon: () => void;
  isCouponEnabledForPaymentType: () => boolean;
}

const SummaryModalBody: React.FC<SummaryModalBodyProps> = ({
  sections,
  selectedOption,
  setSelectedOption,
  handleOptionChange,
  checkOutItems,
  proceedToBuy,
  isPurchaseButtonClicked,
  showAlert,
  couponState,
  couponInput,
  setCouponInput,
  handleApplyCoupon,
  handleRemoveCoupon,
  isCouponEnabledForPaymentType,
}) => {
  const prepaid = sessionStorage.getItem("prepaid");
  const cod = sessionStorage.getItem("cod");
  const { nfoSelected } = useContext(CartContext);
  const nfoSelectedSession = sessionStorage.getItem("nfoSelected");
  const nfoSelectedBoolean = nfoSelectedSession === "true";

  return (
    <div className="summary-modal-body">
      <div className="summary-row">
        <div className="summary-grid">
          {sections.map((section, index) => (
            <div
              style={{
                backgroundColor: "rgba(44, 106, 177, 0.1)",
                padding: "20px",
                borderRadius: "8px",
                boxShadow: "0px 0px 10px 0px rgba(0, 0, 0, 0.01)",
              }}
              key={index}
            >
              <div className="summary-title">{section.title}</div>
              <div className="summary-subtitle">{section.subTitle}</div>
            </div>
          ))}
        </div>
        <div className="summary-modal-body-right">
          <div className="radio-group">
            {prepaid === "true" && (
              <div
                onClick={() => {
                  console.log("📻 Prepaid div onClick triggered");
                  const event = {
                    target: { value: "prepaid" },
                  } as React.ChangeEvent<HTMLInputElement>;
                  handleOptionChange(event);
                }}
                className="radio-group-item"
              >
                <div>
                  <input
                    type="radio"
                    id="prepaid"
                    name="prepaid"
                    value="prepaid"
                    checked={selectedOption === "prepaid"}
                    onChange={(e) => {
                      console.log("📻 Prepaid input onChange triggered");
                      handleOptionChange(e);
                    }}
                    className="custom-radio"
                  />
                  <label className="radio-group-label" htmlFor="prepaid">
                    <strong>Prepaid</strong>
                    {!nfoSelected && !nfoSelectedBoolean && (
                      <div>Recommended mode of payment</div>
                    )}
                  </label>
                </div>
                {/* <div
                  style={{
                    backgroundColor: "rgba(44, 106, 177, 1)",
                    padding: "10px",
                    color: "white",
                    fontSize: "12px",
                    fontWeight: 600,
                    fontFamily: "OggTextRegular",
                    borderRadius: "8px",
                    width: "fit-content",
                    marginTop: "10px",
                  }}
                >
                  Extra 5% OFF
                </div> */}
              </div>
            )}
            {/* COD option temporarily hidden */}
            {/* {cod === "true" &&
              nfoSelected === false &&
              nfoSelectedBoolean === false && (
                <div
                  onClick={() => {
                    console.log("📻 COD div onClick triggered");
                    const event = {
                      target: { value: "cod" },
                    } as React.ChangeEvent<HTMLInputElement>;
                    handleOptionChange(event);
                  }}
                  className="radio-group-item"
                >
                  <div>
                    <input
                      type="radio"
                      id="cod"
                      name="cod"
                      value="cod"
                      checked={selectedOption === "cod"}
                      onChange={(e) => {
                        console.log("📻 COD input onChange triggered");
                        handleOptionChange(e);
                      }}
                      className="custom-radio"
                    />
                    <label className="radio-group-label" htmlFor="cod">
                      <strong>COD</strong>
                      <div>Cash on Delivery will incur additional charges</div>
                    </label>
                  </div>
                </div>
              )} */}
          </div>

          {/* Coupon Section */}
          {/* {isCouponEnabledForPaymentType() && (
            <div className="coupon-section" style={{ marginBottom: "20px" }}>
              <div
                className="coupon-input-wrapper"
                style={{ display: "flex", gap: "10px", marginBottom: "15px" }}
              >
                <input
                  type="text"
                  placeholder="Enter coupon code"
                  value={couponInput}
                  onChange={(e) => setCouponInput(e.target.value.toUpperCase())}
                  style={{
                    flex: 1,
                    padding: "12px",
                    border: "1px solid #ddd",
                    borderRadius: "8px",
                    fontSize: "16px",
                    fontFamily: '"Cardo", Helvetica',
                    transition: "border-color 0.2s ease",
                  }}
                  disabled={couponState.isApplied}
                />
                <button
                  onClick={handleApplyCoupon}
                  disabled={couponState.isLoading || couponState.isApplied}
                  style={{
                    padding: "12px 20px",
                    backgroundColor:
                      couponState.isLoading || couponState.isApplied
                        ? "#ccc"
                        : "white",
                    color: "#376CAA",
                    border: "none",
                    borderRadius: "8px",
                    cursor:
                      couponState.isLoading || couponState.isApplied
                        ? "not-allowed"
                        : "pointer",
                    fontSize: "16px",
                    fontWeight: 600,
                    fontFamily: '"Cardo", Helvetica',
                    whiteSpace: "nowrap",
                    boxShadow: "0px 0px 10px 0px rgba(0, 0, 0, 0.01)",
                  }}
                >
                  {couponState.isLoading ? "Applying..." : "Apply"}
                </button>
              </div>

              {couponState.isApplied && (
                <div
                  style={{
                    background:
                      "linear-gradient(135deg, #f8fbff 0%, #e8f2ff 100%)",
                    border: "1px solid #b3d4fc",
                    borderRadius: "12px",
                    padding: "16px",
                    marginBottom: "15px",
                    boxShadow: "0 2px 8px rgba(55, 108, 170, 0.1)",
                  }}
                >
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: "8px",
                      marginBottom: "12px",
                    }}
                  >
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        flexShrink: 0,
                      }}
                    >
                      <svg
                        width="20"
                        height="20"
                        viewBox="0 0 24 24"
                        fill="none"
                      >
                        <path
                          d="M9 12L11 14L15 10M21 12C21 16.9706 16.9706 21 12 21C7.02944 21 3 16.9706 3 12C3 7.02944 7.02944 3 12 3C16.9706 3 21 7.02944 21 12Z"
                          stroke="#10B981"
                          strokeWidth="2"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        />
                      </svg>
                    </div>
                    <span
                      style={{
                        flex: 1,
                        color: "#376CAA",
                        fontSize: "14px",
                        fontWeight: 500,
                        fontFamily: '"Cardo", Helvetica',
                      }}
                    >
                      Coupon <strong>"{couponState.code}"</strong> applied
                      successfully!
                    </span>
                    <button
                      onClick={handleRemoveCoupon}
                      style={{
                        background: "none",
                        border: "none",
                        cursor: "pointer",
                        padding: "4px",
                        borderRadius: "4px",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                      }}
                      title="Remove coupon"
                    >
                      <svg
                        width="16"
                        height="16"
                        viewBox="0 0 24 24"
                        fill="none"
                      >
                        <path
                          d="M18 6L6 18M6 6L18 18"
                          stroke="#6B7280"
                          strokeWidth="2"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        />
                      </svg>
                    </button>
                  </div>
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "center",
                    }}
                  >
                    <span
                      style={{
                        color: "#374151",
                        fontSize: "14px",
                        fontWeight: 500,
                        fontFamily: '"Cardo", Helvetica',
                      }}
                    >
                      Discount:
                    </span>
                    <span
                      style={{
                        fontSize: "14px",
                        fontWeight: 600,
                        fontFamily: '"Cardo", Helvetica',
                        color: "#10B981",
                      }}
                    >
                      -₹{couponState.discountAmount}
                    </span>
                  </div>
                </div>
              )}

              
              {couponState.error && (
                <div
                  style={{
                    background:
                      "linear-gradient(135deg, #fff8f8 0%, #ffe8e8 100%)",
                    border: "1px solid #ffcdd2",
                    borderRadius: "12px",
                    padding: "12px",
                    marginBottom: "15px",
                    boxShadow: "0 2px 8px rgba(244, 67, 54, 0.1)",
                  }}
                >
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: "8px",
                    }}
                  >
                    <svg width="16" height="16" viewBox="0 0 24 24" fill="none">
                      <path
                        d="M12 9V13M12 17H12.01M21 12C21 16.9706 16.9706 21 12 21C7.02944 21 3 16.9706 3 12C3 7.02944 7.02944 3 12 3C16.9706 3 21 7.02944 21 12Z"
                        stroke="#EF4444"
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                    </svg>
                    <span
                      style={{
                        color: "#dc2626",
                        fontSize: "14px",
                        fontWeight: 500,
                        fontFamily: '"Cardo", Helvetica',
                      }}
                    >
                      {couponState.error}
                    </span>
                  </div>
                </div>
              )}
            </div>
          )} */}

          <ItemSummary items={checkOutItems} selectedOption={selectedOption} />

          <button
            className="buy-button"
            onClick={() => {
              proceedToBuy(selectedOption);
            }}
          >
            {!isPurchaseButtonClicked && <div>Proceed to buy</div>}
            {isPurchaseButtonClicked && <div>Loading....</div>}
          </button>

          {showAlert.alert && (
            <Alert
              style={{
                borderRadius: 10,
                opacity: 1,
                marginTop: "10px",
              }}
              severity="error"
            >
              {showAlert.alert}
            </Alert>
          )}
        </div>
      </div>
    </div>
  );
};

export default SummaryModalBody;
